import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, ReplaySubject, Subject, combineLatest } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { CompareFacade } from 'src/app/extensions/compare/facades/compare.facade';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductCompletenessLevel } from 'ish-core/models/product/product.model';
import { whenTruthy } from 'ish-core/utils/operators';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ModalDialogComponent as ModalDialogComponent_1 } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

@Component({
  selector: 'custom-filter-compare',
  templateUrl: './filter-compare.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, RouterLink, ModalDialogComponent_1, AsyncPipe, TranslateModule],
})
export class FilterCompareComponent implements OnInit {
  private shoppingFacade = inject(ShoppingFacade);
  private compareFacade = inject(CompareFacade);
  private translate = inject(TranslateService);

  /**
   * The list of products to compare
   */
  @Input()
  set compareProducts(val: string[]) {
    this.compareProductSKUs$.next(val);
  }
  compareProductSKUs$ = new ReplaySubject<string[]>(1);
  compareProducts$: Observable<ProductView[]>;
  private destroy$ = new Subject<void>();
  ngOnInit() {
    this.compareProducts$ = this.compareProductSKUs$.pipe(
      switchMap(skus =>
        combineLatest(skus.map(sku => this.shoppingFacade.product$(sku, ProductCompletenessLevel.Detail)))
      )
    );
  }

  removeFromCompare(sku: string) {
    this.compareFacade.removeProductFromCompare(sku);
  }

  clearAllFromCompare() {
    this.compareProductSKUs$
      .pipe(whenTruthy(), take(1), takeUntil(this.destroy$))
      .subscribe(skus => skus.map(sku => this.compareFacade.removeProductFromCompare(sku)));

    this.compareProducts$ = this.compareProductSKUs$.pipe(
      switchMap(skus =>
        combineLatest(skus.map(sku => this.shoppingFacade.product$(sku, ProductCompletenessLevel.Detail)))
      )
    );
  }
  openDeleteConfirmationDialog(sku: string, modal: ModalDialogComponent<string>) {
    modal.options().titleText = this.translate.instant('dias.filter.compare.product.delete_dialog.header');
    modal.show(sku);
  }
  openClearAllConfirmationDialog(modal: ModalDialogComponent<string>) {
    modal.options().titleText = this.translate.instant('dias.filter.compare.product.clear_all_dialog.header');
    modal.show();
  }
}
